import jQuery from 'jquery';
import 'jquery-colorbox';

const colorboxDefaults = {
	transition: 'fade',
	fixed: true,
	width: 1200,
	height: 720,
	opacity: .75,
	scalePhotos: true,
	maxWidth: '95%',
	maxHeight: '95%',
	initialWidth: 500,
	initialHeight: 300,
	close: '<span>Close</span>'
};
const VideoLightbox = () => {
	const colorboxConfig = jQuery.extend({}, colorboxDefaults, {
		className: 'videoLightbox',
		iframe: true,
		rel: false
	});

	// Autoplay video if the URL includes ?rd=1
	const urlParams = new URLSearchParams(window.location.search);
	if(urlParams.get('rd') === '1') {
		jQuery.colorbox({
			href: "https://player.vimeo.com/video/857675724?autoplay=1&muted=1&loop=1",
			iframe: true,
			width: 1200,
			height: 720,
			close: '<span>Close</span>'
		});
	}

	jQuery('a[href*="youtube.com/embed/"], a[href*="youtu.be/"], a[href*="vimeo.com"]').colorbox(colorboxConfig);
};

export default VideoLightbox;


// https://player.vimeo.com/progressive_redirect/playback/857675724/rendition/1080p/file.mp4?loc=external&signature=e88110d37a42c16016755761b28e6f5f9df854700ab023a9cf60a27d36e183d1
